import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { Observable } from 'rxjs';
import { API_URL } from '../../../../../services/config';
import { ListClientPaginationStateModel } from '../../../../../common/models';
import { AllocationViewProfile, AllocationViewProfileListSearchCriteria } from '../models';
import { AllocationViewProfilesEndpoint } from '../constants';
import { getQueryStringFromObject } from '../../../../../common/utils';

@Injectable({ providedIn: 'root' })
export class AllocationViewProfileListService {
  constructor(private http: WrapperHttpService) {}

  getProfiles(
    searchCriteria: AllocationViewProfileListSearchCriteria,
  ): Observable<ListClientPaginationStateModel<AllocationViewProfile>> {
    const url = `${API_URL}${AllocationViewProfilesEndpoint.DockAndYard}${AllocationViewProfilesEndpoint.Monitoring}${
      AllocationViewProfilesEndpoint.Profile
    }?${getQueryStringFromObject(searchCriteria)}`;

    return this.http.withLoading().get<ListClientPaginationStateModel<AllocationViewProfile>>(url);
  }
}
